export type JourneyPhase = 'explore' | 'planning' | 'route_ready' | 'navigating';

export type SheetSnap = 'compact' | 'medium' | 'expanded';

export type JourneyState = {
  phase: JourneyPhase;
  snap: SheetSnap;
  surface: 'none' | 'journey' | 'tools';
};

export type JourneyEvent =
  | { type: 'OPEN_PLANNER' }
  | { type: 'ROUTE_READY' }
  | { type: 'START_NAVIGATION' }
  | { type: 'SET_SNAP'; snap: SheetSnap }
  | { type: 'OPEN_TOOLS' }
  | { type: 'OPEN_JOURNEY' }
  | { type: 'CLOSE_JOURNEY' }
  | { type: 'CLEAR_ROUTES' }
  | { type: 'ESCAPE' };

export const initialJourneyState: JourneyState = {
  phase: 'explore',
  snap: 'compact',
  surface: 'none'
};

export function reduceJourney(state: JourneyState, event: JourneyEvent): JourneyState {
  switch (event.type) {
    case 'OPEN_PLANNER':
      return state.phase === 'explore' ? { ...state, phase: 'planning' } : state;
    case 'ROUTE_READY':
      return state.phase === 'planning' ? { ...state, phase: 'route_ready' } : state;
    case 'START_NAVIGATION':
      return state.phase === 'route_ready' ? { ...state, phase: 'navigating' } : state;
    case 'SET_SNAP':
      return { ...state, snap: event.snap };
    case 'OPEN_TOOLS':
      return { ...state, surface: 'tools' };
    case 'OPEN_JOURNEY':
      return { ...state, surface: 'journey' };
    case 'CLOSE_JOURNEY':
      return state.surface === 'journey' ? { ...state, surface: 'none' } : state;
    case 'CLEAR_ROUTES':
      return { ...state, phase: 'planning' };
    case 'ESCAPE':
      if (state.surface === 'tools') return { ...state, surface: 'none' };
      if (state.surface !== 'journey') return state;
      if (state.snap === 'expanded') return { ...state, snap: 'medium' };
      if (state.snap === 'medium') return { ...state, snap: 'compact' };
      return { ...state, surface: 'none' };
  }
}
